import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MsSwitch from '../../general/input/MsSwitch.vue'



export default /*@__PURE__*/_defineComponent({
  __name: 'DoBSwitch',
  emits: ['show-delta'],
  setup(__props, { emit: __emit }) {

const emit = __emit

function updateShowDelta(newValue: boolean) {
  emit('show-delta', newValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MsSwitch, {
    checked: false,
    text: 'Relative to seabed',
    id: 'chartseabed',
    onValueChanged: _cache[0] || (_cache[0] = (checked) => updateShowDelta(checked))
  }))
}
}

})